import React, { FC } from 'react';
import { Grid, Box } from '@mui/material';
import { BlogsListSectionProps } from 'views/rebranded-module/blogs-module/BlogsViewV2/components/BlogsListSection/BlogsListSection.interface';
import { BlogCardV2 } from 'views/rebranded-module/common/components';
import PATHS from 'lib/navigation/paths';

// Helper function to determine Grid sizing
const getGridProps = (index: number) => {
  if (index === 0) {
    return { xs: 12 };
  } else if (index >= 1 && index <= 4) {
    // 2nd and 3rd row: 2 cards each
    return { sm: 12, md: 6, lg: 6 };
  } else {
    // 4th row and beyond: 3 cards per row
    return { sm: 12, md: 6, lg: 4 };
  }
};

const BlogsListSection: FC<BlogsListSectionProps> = (props) => {
  const { blogs } = props;
  return (
    <Box mb={8}>
      <Grid container columnSpacing={4} rowSpacing={6}>
        {blogs.map((blog, index) => (
          <Grid key={blog.id} item {...getGridProps(index)}>
            <BlogCardV2
              title={blog.title}
              description={blog.description}
              image={blog.cover_image?.large_url}
              date={blog.posted_on}
              path={PATHS.motorcycleTouring.slug(blog.slug)}
              stretched={index === 0} // only first card is stretched
            />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};

export { BlogsListSection };
